import { useMemo } from 'react';

import { useLocation } from '../contexts/RouterContext';

/**
 * Helper hook to determine if the page you're on is for a project, a release group, or neither.
 * @returns
 *    - `project` if we're in a Project page
 *    - `releaseGroup` if we're in a Release Group page
 *    - `null` if we're in neither (for example, the main dashboard or the org settings)
 */
const useGetScope = (): 'project' | 'releaseGroup' | null => {
  const { pathname } = useLocation();

  return useMemo(() => {
    if (pathname.startsWith('/projects/group')) {
      return 'releaseGroup';
    }

    if (pathname.startsWith('/projects/')) {
      return 'project';
    }

    return null;
  }, [pathname]);
};

export default useGetScope;
